import { PrimaryButton } from "@certn/cascadia";
import { CascadiaIllustration } from "@certn/cascadia-tokens";
import { useState } from "react";

import { SignUpRegionPage } from "../pages/sign-up-region-page/SignUpRegionPage";
import { FullScreenErrorPage } from "./FullScreenErrorPage";

interface Props {
  title: string;
  message: string;
  buttonText: string;
  icon: CascadiaIllustration;
}

export function NoAccessOrSignUpRegion(props: Props) {
  const { title, message, buttonText, icon } = props;
  const [showSignUpRegionPage, setShowSignUpRegionPage] = useState(false);

  if (showSignUpRegionPage) {
    return <SignUpRegionPage onClose={() => setShowSignUpRegionPage(false)} />;
  }

  return (
    <FullScreenErrorPage title={title} message={message} illustration={icon}>
      <PrimaryButton
        type="button"
        variant="info"
        onPress={() => setShowSignUpRegionPage(!showSignUpRegionPage)}
      >
        {buttonText}
      </PrimaryButton>
    </FullScreenErrorPage>
  );
}
